import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { makeAutoObservable } from 'mobx'
import { InferenceStore } from 'store/inference/InferenceStore'
import { OfferItem } from 'type/rec'

export class FullscreenStore {
  inferences?: CarouselStore<InferenceStore>
  recommendations?: CarouselStore<OfferItem>

  static fromInferences(inferences: InferenceStore[], index: number) {
    const store = new FullscreenStore()
    store.inferences = new CarouselStore(inferences)
    store.inferences.index = index
    return store
  }

  static fromRecommendations(items: OfferItem[], index: number) {
    const store = new FullscreenStore()
    store.recommendations = new CarouselStore(items, { ratio: 1 / 1 })
    store.recommendations.index = index
    return store
  }

  private constructor() {
    makeAutoObservable(this)
  }
}
